import { z, ZodTypeAny } from "zod";
import * as Constants from "@/constants";

interface Schema {
  key: string;
  required?: boolean;
  nullable?: boolean;
  optional?: boolean;
  min?: number;
  max?: number;
  length?: number;
  regex?: RegExp;
}

interface StringSchema extends Schema {
  type?: "string" | "email";
}

const stringSchema = ({
  key,
  type,
  optional,
  required,
  nullable,
  min,
  max,
  length,
  regex,
}: StringSchema): ZodTypeAny => {
  let zodSchema: any = z.string({
    required_error: Constants.INPUT_ERRORS.REQUIRED(key),
    invalid_type_error: Constants.INPUT_ERRORS.INVALID_TYPE(key, "string"),
  });

  if (type === "email") {
    zodSchema = zodSchema.email({
      message: Constants.INPUT_ERRORS.INVALID_TYPE(key, "email"),
    });
  }

  if (required) {
    zodSchema = zodSchema.min(1, {
      message: Constants.INPUT_ERRORS.REQUIRED(key),
    });
  } else {
    if (optional) zodSchema = zodSchema.optional();
    if (nullable) zodSchema = zodSchema.nullable();
  }

  if (length) {
    zodSchema = zodSchema.length(length, {
      message: Constants.INPUT_ERRORS.INVALID_LENGTH(key, length),
    });
  }

  if (min) {
    zodSchema = zodSchema.min(min, {
      message: Constants.INPUT_ERRORS.MIN_LENGTH(key, min),
    });
  }

  if (max) {
    zodSchema = zodSchema.max(max, {
      message: Constants.INPUT_ERRORS.MAX_LENGTH(key, max),
    });
  }

  if (regex) {
    zodSchema = zodSchema.regex(regex, {
      message: Constants.INPUT_ERRORS.INVALID_TYPE(key, "string"),
    });
  }

  return zodSchema;
};

export default stringSchema;
